import dayjs from 'dayjs'
import { IDocumentDefault } from '../../../../api/types'
import { TTableDataCountDisplay, TTableHeader } from '@reapitform/common-ui'
import { getFileSizeDisplay } from '@reapitform/utils'

const documentTableHeaders: TTableHeader<IDocumentDefault>[] = [
  {
    headerTitle: 'FORM',
    key: 'formType',
    sortAs: 'FormType',
    sortable: true,
    columnWidth: '250px',
  },
  {
    headerTitle: 'DOCUMENT NAME',
    key: 'documentName',
  },
  {
    headerTitle: 'FILE SIZE',
    key: 'defaultAttachmentFileSize',
    getColumnValue: (data) => getFileSizeDisplay(data.defaultAttachmentFileSize),
    columnWidth: '140px',
  },
  {
    headerTitle: 'UPLOADED',
    key: 'lastUpdatedUTC',
    getColumnValue: (data) => dayjs(data.lastUpdatedUTC).format('D MMM YYYY'),
    sortAs: 'LastActionDate',
    sortable: true,
    columnWidth: '140px',
  },
]

const tableCountDisplayConfig: TTableDataCountDisplay = {
  singular: 'Document',
  plural: 'Documents',
}

export const documentTableConfig = {
  header: documentTableHeaders,
  countDisplay: tableCountDisplayConfig,
  emptyMessages: 'There are no default documents',
  description: 'Documents will be added to the form by default and emailed to the recipient with their agreement.',
}
